import React, { useState } from "react";
import "./App.css";

/* ─────────────────────────────────────────────────────────
   DATA
───────────────────────────────────────────────────────── */
const PROJECTS = [
  {
    id: 1,
    title: "Digitomics",
    tools: ["tableau"],
    image: "/images/digitomics.png",
    techStack: ["Python", "Tableau", "Pandas", "Numpy"],
    description:
      "Analyses how 100,000 students across 50+ countries' digital habits impact academic performance, mental health and financial behaviour.",
    demo: "https://public.tableau.com/views/DVA_project_17772624361540/DashboardPage1?:language=en-US&:sid=&:redirect=auth&:display_count=n&:origin=viz_share_link",
  },
  {
    id: 2,
    title: "Uber Dataset Analysis",
    tools: ["tableau"],
    image: "/images/uber.png",
    techStack: ["Tableau", "Kaggle"],
    description:
      "Comprehensive Uber analytics dashboard covering ride data across multiple cities with fare vs distance plots and real-time KPI cards.",
    demo: "https://public.tableau.com/views/Book2_17774370355220/Dashboard1?:language=en-US&:sid=&:redirect=auth&:display_count=n&:origin=viz_share_link",
  },
  {
    id: 3,
    title: "Airbnb Dataset Analysis",
    tools: ["excel"],
    image: "/images/airbnb.png",
    techStack: ["Google Sheets", "Excel"],
    description:
      "Airbnb analytics dashboard visualizing price, occupancy, revenue and ratings across neighbourhoods with interactive filters.",
    demo: "https://docs.google.com/spreadsheets/d/1TTPamPpV72Js0CgEmxKFcvHeBpP7hqC0_AADeyaLDj4/edit?usp=sharing",
  },
];

const STORIES = [
  { id: "tableau", label: "Tableau", image: "/images/tableau.png" },
  { id: "excel",   label: "Excel",   image: "/images/excel.png"   },
  { id: "looker",  label: "Looker",  image: "/images/looker.svg"  },
];

/* ─────────────────────────────────────────────────────────
   INLINE SVG ICONS  (Instagram-themed stroke style)
───────────────────────────────────────────────────────── */
const LinkedInIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="#0a66c2">
    <path d="M20.45 20.45h-3.554v-5.569c0-1.328-.024-3.037-1.85-3.037-1.851 0-2.134 1.445-2.134 2.939v5.667H9.358V9h3.414v1.561h.047c.476-.9 1.637-1.85 3.37-1.85 3.602 0 4.268 2.37 4.268 5.455v6.284zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.017H3.555V9h3.564v11.45zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const GitHubIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="#1b1f23">
    <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" />
  </svg>
);

/* Profile info icons – thin stroke style like Instagram */
const PhoneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="#8e8e8e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6.07 6.07l.95-.95a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);

const EmailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="#8e8e8e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);

const SchoolIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="#8e8e8e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
    <path d="M6 12v5c3 3 9 3 12 0v-5"/>
  </svg>
);

const LocationIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="#8e8e8e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);

/* Instagram post action icons */
const HeartIcon = ({ filled }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
    fill={filled ? "#ed4956" : "none"}
    stroke={filled ? "#ed4956" : "#262626"}
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
  >
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
  </svg>
);

const CommentIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#262626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
  </svg>
);

const ShareIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#262626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="22" y1="2" x2="11" y2="13"/>
    <polygon points="22 2 15 22 11 13 2 9 22 2"/>
  </svg>
);

/* ─────────────────────────────────────────────────────────
   STORY CIRCLE (tool filter)
───────────────────────────────────────────────────────── */
function StoryCircle({ story, selected, onClick }) {
  const [hovered, setHovered] = useState(false);
  const active = selected || hovered;
  return (
    <div className="story-wrapper" onClick={() => onClick(story.id)}>
      <div
        className={`story-ring ${active ? "story-ring--active" : "story-ring--inactive"}`}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <div className="story-inner">
          <img src={story.image} alt={story.label} className="story-img" />
        </div>
      </div>
      <span className="story-label">{story.label}</span>
    </div>
  );
}

/* ─────────────────────────────────────────────────────────
   PROJECT CARD  (Instagram post style)
───────────────────────────────────────────────────────── */
function ProjectCard({ project, onClick }) {
  const [liked, setLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(Math.floor(Math.random() * 80) + 20);
  const [justLiked, setJustLiked] = useState(false);

  const handleLike = (e) => {
    e.stopPropagation();
    if (!liked) {
      setJustLiked(true);
      setTimeout(() => setJustLiked(false), 400);
      setLikeCount((c) => c + 1);
    } else {
      setLikeCount((c) => c - 1);
    }
    setLiked((l) => !l);
  };

  const handleShare = (e) => {
    e.stopPropagation();
    if (navigator.share) {
      navigator.share({ title: project.title, url: project.demo }).catch((err) => {
        /* Silently ignore if user cancels the native share sheet */
        if (err.name !== 'AbortError') {
          navigator.clipboard.writeText(project.demo);
        }
      });
    } else {
      navigator.clipboard.writeText(project.demo);
    }
  };

  return (
    <div className="project-card">
      {/* Image area – clickable to open modal */}
      <div className="card-image-wrap" onClick={() => onClick(project)}>
        <img src={project.image} alt={project.title} className="card-img" />
        {/* Tool pills overlaid on image */}
        <div className="card-pills">
          {project.techStack.map((t) => (
            <span key={t} className="card-pill">{t}</span>
          ))}
        </div>
      </div>

      {/* Card body */}
      <div className="card-body">
        <h3 className="card-title">{project.title}</h3>
        <p className="card-desc">{project.description}</p>

        {/* Instagram-style action bar */}
        <div className="card-actions">
          <div className="card-actions-left">
            <button
              className={`action-btn ${justLiked ? "action-btn--pop" : ""}`}
              onClick={handleLike}
              aria-label="Like"
            >
              <HeartIcon filled={liked} />
            </button>
            <button className="action-btn" onClick={(e) => { e.stopPropagation(); onClick(project); }} aria-label="Comment">
              <CommentIcon />
            </button>
            <button className="action-btn" onClick={handleShare} aria-label="Share">
              <ShareIcon />
            </button>
          </div>
        </div>
        <span className="card-likes">{likeCount} likes</span>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────────────────
   MODAL
───────────────────────────────────────────────────────── */
function Modal({ project, onClose }) {
  if (!project) return null;
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        <img src={project.image} alt={project.title} className="modal-img" />
        <div className="modal-body">
          <h2 className="modal-title">{project.title}</h2>
          <div className="modal-tags">
            {project.techStack.map((t) => (
              <span key={t} className="modal-tag">{t}</span>
            ))}
          </div>
          <p className="modal-desc">{project.description}</p>
          <a href={project.demo} target="_blank" rel="noopener noreferrer" className="modal-btn">
            View Demo →
          </a>
        </div>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────────────────
   MAIN APP
───────────────────────────────────────────────────────── */
export default function App() {
  const [selectedStory, setSelectedStory] = useState(null);
  const [activeModal, setActiveModal]     = useState(null);

  const handleStoryClick = (id) =>
    setSelectedStory((prev) => (prev === id ? null : id));

  let visibleProjects = PROJECTS;
  if (selectedStory === "tableau") visibleProjects = PROJECTS.filter((p) => p.tools.includes("tableau"));
  else if (selectedStory === "excel")   visibleProjects = PROJECTS.filter((p) => p.tools.includes("excel"));
  else if (selectedStory === "looker")  visibleProjects = [];

  return (
    <div className="page">

      {/* ══ PROFILE ══ */}
      <section className="profile-section">

        {/* Profile photo with gradient story ring */}
        <div className="profile-photo-outer">
          <div className="profile-story-ring">
            <div className="profile-story-gap">
              <img src="/images/profile.jpg" alt="Soumya Tiwari" className="profile-photo" />
            </div>
          </div>
        </div>

        {/* Info */}
        <div className="profile-info">
          <h1 className="profile-name">Soumya Tiwari</h1>

          <div className="profile-stats">
            <span><strong>3</strong> posts</span>
            <span className="stats-dot">·</span>
            <span><strong>2</strong> tools</span>
            <span className="stats-dot">·</span>
            <span><strong>3</strong> projects</span>
          </div>

          {/* 2-line bio */}
          <div className="profile-bio">
            <p className="bio-headline">Analytical and results-driven Data Analyst</p>
            <p className="bio-sub">Expertise in data cleaning, exploration &amp; visualization using Excel, Python, Tableau and Looker Studio.</p>
          </div>

          {/* Meta info with icons */}
          <div className="profile-meta">
            <span className="meta-item">
              <SchoolIcon /> Newton School of Technology
            </span>
            <span className="meta-item">
              <LocationIcon /> Sonipat, Haryana
            </span>
            <span className="meta-item">
              <PhoneIcon /> +91 7495042431
            </span>
            <span className="meta-item">
              <EmailIcon /> soumya.tiwari2024@nst.rishihood.edu.in
            </span>
          </div>

          {/* Social buttons */}
          <div className="profile-links">
            <a href="https://www.linkedin.com/in/soumya-tiwari-766430323/" target="_blank" rel="noopener noreferrer" className="icon-btn" aria-label="LinkedIn">
              <LinkedInIcon />
            </a>
            <a href="https://github.com/soumyatiw" target="_blank" rel="noopener noreferrer" className="icon-btn" aria-label="GitHub">
              <GitHubIcon />
            </a>
          </div>
        </div>
      </section>

      <div className="divider" />

      {/* ══ TOOL STORIES ══ */}
      <section className="stories-section">

        {/* All – FIRST, uses same ring style as other circles */}
        <div
          className="story-wrapper"
          onClick={() => setSelectedStory(null)}
          title="Show all projects"
        >
          <div className={`story-ring ${selectedStory === null ? 'story-ring--active' : 'story-ring--inactive'}`}>
            <div className="story-inner">
              {/* 2×2 grid with Instagram gradient colours */}
              <svg viewBox="0 0 24 24" width="38" height="38" fill="none">
                <rect x="2"  y="2"  width="9" height="9" rx="2" fill="#f09433" />
                <rect x="13" y="2"  width="9" height="9" rx="2" fill="#dc2743" />
                <rect x="2"  y="13" width="9" height="9" rx="2" fill="#cc2366" />
                <rect x="13" y="13" width="9" height="9" rx="2" fill="#bc1888" />
              </svg>
            </div>
          </div>
          <span className="story-label">All</span>
        </div>

        {STORIES.map((s) => (
          <StoryCircle
            key={s.id}
            story={s}
            selected={selectedStory === s.id}
            onClick={handleStoryClick}
          />
        ))}
      </section>

      <div className="divider" />

      {/* ══ PROJECTS ══ */}
      <section className="grid-section">
        {selectedStory === "looker" ? (
          <div className="coming-soon">
            <p>Coming Soon</p>
          </div>
        ) : visibleProjects.length === 0 ? (
          <div className="coming-soon"><p>No projects found.</p></div>
        ) : (
          <div className="project-grid">
            {visibleProjects.map((p) => (
              <ProjectCard key={p.id} project={p} onClick={setActiveModal} />
            ))}
          </div>
        )}
      </section>

      {/* ══ MODAL ══ */}
      <Modal project={activeModal} onClose={() => setActiveModal(null)} />
    </div>
  );
}
